import template from './presseticketcode.html';
import controller from './presseticketcode.controller';
import './presseticketcode.scss';

let presseticketcodeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default presseticketcodeComponent;



// WEBPACK FOOTER //
// ./client/app/common/forms/presseticketcode/presseticketcode.component.js